import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-take-off',
  templateUrl: './take-off.component.html',
  styleUrls: ['./take-off.component.css']
})
export class TakeOffComponent implements OnInit {

  page = 1;
  count = 0;
  tableSize = 15;

  year_select = parseInt(new DatePipe('en-US').transform(new Date(), 'yyyy')!) + 543
  years = [] as any;
  data_all: any = [];
  data_select: any = [];
  today_date = new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd')

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    document.getElementById('personnel-c')!.classList.toggle("active");
    this.today_date = this.dateThaiFormat(this.today_date)
    this.getDataApi()
  }

  ngOnDestroy() {
    if (document.getElementById('personnel-c')) {
      document.getElementById('personnel-c')!.classList.remove("active");
    }
  }

  async getDataApi() {
    this.years = []
    await this.services.year_leave().then((res: any) => {
      res.forEach((e: any) => {
          this.years.push(e.years)
          e.re_recess = Number(e.all_recess) - Number(e.recess)
          e.re_sick = Number(e.all_sick) - Number(e.sick)
          e.re_kij = Number(e.all_kij) - Number(e.kij)
          e.re_deliver = Number(e.all_deliver) - Number(e.deliver)
          e.re_late = Number(e.all_late) - Number(e.late)
          e.re_broken = Number(e.all_broken) - Number(e.broken)
          this.data_all.push(e)
      });
    })
    this.years = [...new Set(this.years)].sort()
    this.select_year();
  }

  select_year() {
    this.data_select = [];
    this.data_select = this.data_all.filter((res: any) => {
      return res.years.match(this.year_select)
    })
  }

  dateThaiFormat(date: any) {
    return date = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
